
// Libraries
var React = require('react');
var hdate = require('human-date');

// Components
var VideoModule = require('Video/VideoModule');
var RestrictedComponent = require('RestrictedComponent/RestrictedComponent');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./RelatedStoriesItem.scss');

class RelatedStoriesItem extends React.Component {
	
	componentWillMount () {
		// Removes the Caption from he video so it fits in place.
		if (this.props.thumbnailType === 'VIDEO') {
			this.setState({
				media: {...this.props.media, "caption": null}
			});
		}
	}

	render() {
		return (
			<div className="RelatedStoriesItem">
				<RestrictedComponent hasAccess={this.props.hasAccess} isVideo={this.props.thumbnailType === 'VIDEO'}>
					<div className="RelatedStoriesItem__image">
						{this.props.thumbnailType === 'VIDEO' ? (
								<div className="RelatedStoriesItem__image__container">
									<VideoModule hasAccess={true} data={this.state.media} publishedDate={this.props.date} />
								</div>
							) : (
								<div className="RelatedStoriesItem__image__container">
									<a href={this.props.url}><img src={PlaceholderImg} data-src={this.props.image.smallUrl} alt={this.props.image.altText}/></a>
								</div>
							)
						}
					</div>
					<div className="RelatedStoriesItem__info">
						<div className="RelatedStoriesItem__tags">
							{this.props.tags.map((item) => {
								return (
									<a className="RelatedStoriesItem__tag" rel="nofollow" href={item.url} key={item.id}>{item.hashtag}</a>
								);
							})}
						</div>
						<a href={this.props.url}><div className="RelatedStoriesItem__headline">{this.props.title}</div></a>
						
						{this.props.hasDate ? (
								<a href={this.props.url}><div className="RelatedStoriesItem__timestamp">{hdate.relativeTime(new Date(this.props.dateUtc))}</div></a>
								
							) : (
								<a href={this.props.url}><div className="RelatedStoriesItem__timestamp">&nbsp;</div></a>
							)
						}

					</div>
				</RestrictedComponent>
			</div>
		)
	}
}

module.exports = RelatedStoriesItem;



// WEBPACK FOOTER //
// ./src/components/RelatedStories/RelatedStoriesItem.js